module.exports = __webpack_public_path__ + "img/Belts.6b1a80ff.jpg";